  window.dataLayer = window.dataLayer || [];

  function generateUniqueID() {
      return "nav-" + Math.random().toString(36).substr(2, 9);
  }

  function pushBuilderEvent(action, eventDetail) {
      const configuratorType = window.location.pathname.includes("ps4") ? "ps4" :
                               window.location.pathname.includes("ps5") ? "ps5" :
                               window.location.pathname.includes("xsx") ? "xsx" : "unknown";

      const cartItems = eventDetail?.cart || [];
      const formattedCartItems = cartItems.map(function(item) {
          return {
              item_id: item.id,
              item_name: item.title,
              price: item.price / 100,
              quantity: item.quantity || 1
          };
      });

      const payload = {
          event: "builder_event",
          builder_action: action,
          configurator_type: eventDetail?.configurator_type || configuratorType,
          category_display_name: eventDetail?.category_display_name || "Unknown",
          display_name: eventDetail?.display_name || "Unknown",
          type: eventDetail?.type || "Unknown",
          option_product: eventDetail?.option_product || "Unknown",
          option_variant: eventDetail?.option_variant || "Unknown",
          internal_name: eventDetail?.internal_name || "Unknown",
          custom_name: eventDetail?.custom_name || "Unknown",
          event_timestamp: new Date().toISOString(),
          page_location: window.location.href
      };

      if (action === "builder_submit") {
          payload.items = formattedCartItems;
      }

      if (action === "builder_navigation") {
          payload.to_internal_id = eventDetail?.to_internal_id || "Unknown";
          payload.to_internal_name = eventDetail?.to_internal_name || "Unknown";
          payload.nav_internal_name = eventDetail?.nav_internal_name || "Unknown";
          payload.nav_internal_id = eventDetail?.nav_internal_id || "Unknown";
          payload.nav_unique_id = generateUniqueID();
      }

      window.dataLayer.push(payload);
      console.log("[GTM] builder_event pushed to dataLayer", payload);
  }

  document.addEventListener("submit", function(event) {
      var eventData = event.detail || {};
      if (!eventData.cart) {
          eventData.cart = window.cart || [];
      }
      pushBuilderEvent("builder_submit", eventData);
  });

  document.addEventListener("selection", function(event) {
      pushBuilderEvent("builder_selection", event.detail);
  });

  document.addEventListener("navigation", function(event) {
      pushBuilderEvent("builder_navigation", event.detail);
  });